"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseJson = exports.response = exports.isPlainObject = exports.isString = void 0;
var sdk_constants_1 = require("./sdk.constants");
var isString = function (candidate) { return typeof candidate === 'string'; };
exports.isString = isString;
var isPlainObject = function (candidate) {
    return typeof candidate === 'object' &&
        candidate !== null &&
        candidate.constructor === Object &&
        Object.prototype.toString.call(candidate) === '[object Object]';
};
exports.isPlainObject = isPlainObject;
var response = function (action) {
    return "".concat(action).concat(sdk_constants_1.HQO_SDK_EVENT_SUFFIX);
};
exports.response = response;
var parseJson = function (text) {
    try {
        return JSON.parse(text);
    }
    catch (_error) {
        return text;
    }
};
exports.parseJson = parseJson;
//# sourceMappingURL=utils.js.map